/**
 * 디자인 토큰 TypeScript 상수 및 헬퍼 함수
 *
 * global.json 기반으로 CSS 변수와 TypeScript 상수를 모두 제공합니다.
 * CSS 변수는 var() 형태로, TypeScript 상수는 직접 값으로 사용할 수 있습니다.
 */
import globalTokens from './global.json';

// === 폰트 토큰 ===
export const FONT = {
  FAMILY: {
    NANUMSQUARE: globalTokens.font.family.nanumsquare.value,
  },
  SIZE: {
    XS: parseInt(globalTokens.font.size['11'].value), // 11px
    SM: parseInt(globalTokens.font.size['12'].value), // 12px
    BASE: parseInt(globalTokens.font.size['14'].value), // 14px
    LG: parseInt(globalTokens.font.size['16'].value), // 16px
    XL: parseInt(globalTokens.font.size['20'].value), // 20px
    '2XL': parseInt(globalTokens.font.size['24'].value), // 24px
    '3XL': parseInt(globalTokens.font.size['28'].value), // 28px
    '4XL': parseInt(globalTokens.font.size['32'].value), // 32px
    '5XL': parseInt(globalTokens.font.size['36'].value), // 36px
    '6XL': parseInt(globalTokens.font.size['48'].value), // 48px
    '7XL': parseInt(globalTokens.font.size['56'].value), // 56px
  },
  WEIGHT: {
    REGULAR: 400,
    BOLD: 700,
    EXTRA_BOLD: 800,
  },
  LINE_HEIGHT: {
    16: parseInt(globalTokens.font.height['16'].value),
    20: parseInt(globalTokens.font.height['20'].value),
    24: parseInt(globalTokens.font.height['24'].value),
    28: parseInt(globalTokens.font.height['28'].value),
    32: parseInt(globalTokens.font.height['32'].value),
    36: parseInt(globalTokens.font.height['36'].value),
    40: parseInt(globalTokens.font.height['40'].value),
    48: parseInt(globalTokens.font.height['48'].value),
    60: parseInt(globalTokens.font.height['60'].value),
    78: parseInt(globalTokens.font.height['78'].value),
  },
} as const;

// === 간격 토큰 ===
export const SPACE = {
  0: parseInt(globalTokens.space['0'].value),
  2: parseInt(globalTokens.space['2'].value),
  4: parseInt(globalTokens.space['4'].value),
  6: parseInt(globalTokens.space['6'].value),
  8: parseInt(globalTokens.space['8'].value),
  10: parseInt(globalTokens.space['10'].value),
  12: parseInt(globalTokens.space['12'].value),
  16: parseInt(globalTokens.space['16'].value),
  18: parseInt(globalTokens.space['18'].value),
  20: parseInt(globalTokens.space['20'].value),
  24: parseInt(globalTokens.space['24'].value),
  28: parseInt(globalTokens.space['28'].value),
  32: parseInt(globalTokens.space['32'].value),
  36: parseInt(globalTokens.space['36'].value),
  40: parseInt(globalTokens.space['40'].value),
  48: parseInt(globalTokens.space['48'].value),
  56: parseInt(globalTokens.space['56'].value),
  60: parseInt(globalTokens.space['60'].value),
} as const;

// === 색상 토큰 ===
export const COLOR = {
  GUIDE: {
    BLANK: globalTokens.palette.guide.blank.value,
  },
  BRAND: {
    BLUE: globalTokens.palette.brand.blue.value,
    ORANGE: globalTokens.palette.brand.orange.value,
  },
  GRAY: {
    0: globalTokens.palette.gray['0'].value,
    10: globalTokens.palette.gray['10'].value,
    20: globalTokens.palette.gray['20'].value,
    30: globalTokens.palette.gray['30'].value,
    40: globalTokens.palette.gray['40'].value,
    50: globalTokens.palette.gray['50'].value,
    60: globalTokens.palette.gray['60'].value,
    70: globalTokens.palette.gray['70'].value,
    80: globalTokens.palette.gray['80'].value,
    90: globalTokens.palette.gray['90'].value,
    94: globalTokens.palette.gray['94'].value,
    98: globalTokens.palette.gray['98'].value,
    100: globalTokens.palette.gray['100'].value,
  },
  RED: {
    0: globalTokens.palette.red['0'].value,
    10: globalTokens.palette.red['10'].value,
    20: globalTokens.palette.red['20'].value,
    30: globalTokens.palette.red['30'].value,
    40: globalTokens.palette.red['40'].value,
    50: globalTokens.palette.red['50'].value,
    60: globalTokens.palette.red['60'].value,
    70: globalTokens.palette.red['70'].value,
    80: globalTokens.palette.red['80'].value,
    90: globalTokens.palette.red['90'].value,
    94: globalTokens.palette.red['94'].value,
    98: globalTokens.palette.red['98'].value,
    100: globalTokens.palette.red['100'].value,
  },
  MAGENTA: {
    0: globalTokens.palette.magenta['0'].value,
    10: globalTokens.palette.magenta['10'].value,
    20: globalTokens.palette.magenta['20'].value,
    30: globalTokens.palette.magenta['30'].value,
    40: globalTokens.palette.magenta['40'].value,
    50: globalTokens.palette.magenta['50'].value,
    60: globalTokens.palette.magenta['60'].value,
    70: globalTokens.palette.magenta['70'].value,
    80: globalTokens.palette.magenta['80'].value,
    90: globalTokens.palette.magenta['90'].value,
    94: globalTokens.palette.magenta['94'].value,
    98: globalTokens.palette.magenta['98'].value,
    100: globalTokens.palette.magenta['100'].value,
  },
  FUCHSIA: {
    0: globalTokens.palette.fuchsia['0'].value,
    10: globalTokens.palette.fuchsia['10'].value,
    20: globalTokens.palette.fuchsia['20'].value,
    30: globalTokens.palette.fuchsia['30'].value,
    40: globalTokens.palette.fuchsia['40'].value,
    50: globalTokens.palette.fuchsia['50'].value,
    60: globalTokens.palette.fuchsia['60'].value,
    70: globalTokens.palette.fuchsia['70'].value,
    80: globalTokens.palette.fuchsia['80'].value,
    90: globalTokens.palette.fuchsia['90'].value,
    94: globalTokens.palette.fuchsia['94'].value,
    98: globalTokens.palette.fuchsia['98'].value,
    100: globalTokens.palette.fuchsia['100'].value,
  },
  PURPLE: {
    0: globalTokens.palette.purple['0'].value,
    10: globalTokens.palette.purple['10'].value,
    20: globalTokens.palette.purple['20'].value,
    30: globalTokens.palette.purple['30'].value,
    40: globalTokens.palette.purple['40'].value,
    50: globalTokens.palette.purple['50'].value,
    60: globalTokens.palette.purple['60'].value,
    70: globalTokens.palette.purple['70'].value,
    80: globalTokens.palette.purple['80'].value,
    90: globalTokens.palette.purple['90'].value,
    94: globalTokens.palette.purple['94'].value,
    98: globalTokens.palette.purple['98'].value,
    100: globalTokens.palette.purple['100'].value,
  },
  INDIGO: {
    0: globalTokens.palette.indigo['0'].value,
    10: globalTokens.palette.indigo['10'].value,
    20: globalTokens.palette.indigo['20'].value,
    30: globalTokens.palette.indigo['30'].value,
    40: globalTokens.palette.indigo['40'].value,
    50: globalTokens.palette.indigo['50'].value,
    60: globalTokens.palette.indigo['60'].value,
    70: globalTokens.palette.indigo['70'].value,
    80: globalTokens.palette.indigo['80'].value,
    90: globalTokens.palette.indigo['90'].value,
    94: globalTokens.palette.indigo['94'].value,
    98: globalTokens.palette.indigo['98'].value,
    100: globalTokens.palette.indigo['100'].value,
  },
  BLUE: {
    0: globalTokens.palette.blue['0'].value,
    10: globalTokens.palette.blue['10'].value,
    20: globalTokens.palette.blue['20'].value,
    30: globalTokens.palette.blue['30'].value,
    40: globalTokens.palette.blue['40'].value,
    50: globalTokens.palette.blue['50'].value,
    60: globalTokens.palette.blue['60'].value,
    70: globalTokens.palette.blue['70'].value,
    80: globalTokens.palette.blue['80'].value,
    90: globalTokens.palette.blue['90'].value,
    94: globalTokens.palette.blue['94'].value,
    98: globalTokens.palette.blue['98'].value,
    100: globalTokens.palette.blue['100'].value,
  },
  TURQUOISE: {
    0: globalTokens.palette.turquoise['0'].value,
    10: globalTokens.palette.turquoise['10'].value,
    20: globalTokens.palette.turquoise['20'].value,
    30: globalTokens.palette.turquoise['30'].value,
    40: globalTokens.palette.turquoise['40'].value,
    50: globalTokens.palette.turquoise['50'].value,
    60: globalTokens.palette.turquoise['60'].value,
    70: globalTokens.palette.turquoise['70'].value,
    80: globalTokens.palette.turquoise['80'].value,
    90: globalTokens.palette.turquoise['90'].value,
    94: globalTokens.palette.turquoise['94'].value,
    98: globalTokens.palette.turquoise['98'].value,
    100: globalTokens.palette.turquoise['100'].value,
  },
  EMERALD: {
    0: globalTokens.palette.emerald['0'].value,
    10: globalTokens.palette.emerald['10'].value,
    20: globalTokens.palette.emerald['20'].value,
    30: globalTokens.palette.emerald['30'].value,
    40: globalTokens.palette.emerald['40'].value,
    50: globalTokens.palette.emerald['50'].value,
    60: globalTokens.palette.emerald['60'].value,
    70: globalTokens.palette.emerald['70'].value,
    80: globalTokens.palette.emerald['80'].value,
    90: globalTokens.palette.emerald['90'].value,
    94: globalTokens.palette.emerald['94'].value,
    98: globalTokens.palette.emerald['98'].value,
    100: globalTokens.palette.emerald['100'].value,
  },
  GREEN: {
    0: globalTokens.palette.green['0'].value,
    10: globalTokens.palette.green['10'].value,
    20: globalTokens.palette.green['20'].value,
    30: globalTokens.palette.green['30'].value,
    40: globalTokens.palette.green['40'].value,
    50: globalTokens.palette.green['50'].value,
    60: globalTokens.palette.green['60'].value,
    70: globalTokens.palette.green['70'].value,
    80: globalTokens.palette.green['80'].value,
    90: globalTokens.palette.green['90'].value,
    94: globalTokens.palette.green['94'].value,
    98: globalTokens.palette.green['98'].value,
    100: globalTokens.palette.green['100'].value,
  },
  OLIVE: {
    0: globalTokens.palette.olive['0'].value,
    10: globalTokens.palette.olive['10'].value,
    20: globalTokens.palette.olive['20'].value,
    30: globalTokens.palette.olive['30'].value,
    40: globalTokens.palette.olive['40'].value,
    50: globalTokens.palette.olive['50'].value,
    60: globalTokens.palette.olive['60'].value,
    70: globalTokens.palette.olive['70'].value,
    80: globalTokens.palette.olive['80'].value,
    90: globalTokens.palette.olive['90'].value,
    94: globalTokens.palette.olive['94'].value,
    98: globalTokens.palette.olive['98'].value,
    100: globalTokens.palette.olive['100'].value,
  },
  CHARTREUSE: {
    0: globalTokens.palette.chartreuse['0'].value,
    10: globalTokens.palette.chartreuse['10'].value,
    20: globalTokens.palette.chartreuse['20'].value,
    30: globalTokens.palette.chartreuse['30'].value,
    40: globalTokens.palette.chartreuse['40'].value,
    50: globalTokens.palette.chartreuse['50'].value,
    60: globalTokens.palette.chartreuse['60'].value,
    70: globalTokens.palette.chartreuse['70'].value,
    80: globalTokens.palette.chartreuse['80'].value,
    90: globalTokens.palette.chartreuse['90'].value,
    94: globalTokens.palette.chartreuse['94'].value,
    98: globalTokens.palette.chartreuse['98'].value,
    100: globalTokens.palette.chartreuse['100'].value,
  },
  YELLOW: {
    0: globalTokens.palette.yellow['0'].value,
    10: globalTokens.palette.yellow['10'].value,
    20: globalTokens.palette.yellow['20'].value,
    30: globalTokens.palette.yellow['30'].value,
    40: globalTokens.palette.yellow['40'].value,
    50: globalTokens.palette.yellow['50'].value,
    60: globalTokens.palette.yellow['60'].value,
    70: globalTokens.palette.yellow['70'].value,
    80: globalTokens.palette.yellow['80'].value,
    90: globalTokens.palette.yellow['90'].value,
    94: globalTokens.palette.yellow['94'].value,
    98: globalTokens.palette.yellow['98'].value,
    100: globalTokens.palette.yellow['100'].value,
  },
  ORANGE: {
    0: globalTokens.palette.orange['0'].value,
    10: globalTokens.palette.orange['10'].value,
    20: globalTokens.palette.orange['20'].value,
    30: globalTokens.palette.orange['30'].value,
    40: globalTokens.palette.orange['40'].value,
    50: globalTokens.palette.orange['50'].value,
    60: globalTokens.palette.orange['60'].value,
    70: globalTokens.palette.orange['70'].value,
    80: globalTokens.palette.orange['80'].value,
    90: globalTokens.palette.orange['90'].value,
    94: globalTokens.palette.orange['94'].value,
    98: globalTokens.palette.orange['98'].value,
    100: globalTokens.palette.orange['100'].value,
  },
} as const;

// === 테두리 반경 토큰 ===
export const RADIUS = {
  4: parseInt(globalTokens.radius['4'].value),
  6: parseInt(globalTokens.radius['6'].value),
  8: parseInt(globalTokens.radius['8'].value),
  12: parseInt(globalTokens.radius['12'].value),
  20: parseInt(globalTokens.radius['20'].value),
  FULL: parseInt(globalTokens.radius['300'].value),
} as const;

// === 투명도 토큰 ===
export const ALPHA = {
  20: 0.2,
  40: 0.4,
  60: 0.6,
} as const;

// === 테두리 두께 토큰 ===
export const BORDER_WIDTH = {
  1: parseInt(globalTokens.border.width['1'].value),
  2: parseInt(globalTokens.border.width['2'].value),
  4: parseInt(globalTokens.border.width['4'].value),
  8: parseInt(globalTokens.border.width['8'].value),
} as const;

// === SEMANTIC 토큰 (light.css 기반) ===

// === Semantic Gap 토큰 ===
export const SEMANTIC_GAP = {
  XXSMALL: '4px', // --opds-sem-gap-xxsmall
  XSMALL: '8px', // --opds-sem-gap-xsmall
  SMALL: '12px', // --opds-sem-gap-small
  REGULAR: '16px', // --opds-sem-gap-regular
  MEDIUM: '20px', // --opds-sem-gap-medium
  XLARGE: '32px', // --opds-sem-gap-xlarge
} as const;

// === Semantic Round 토큰 ===
export const SEMANTIC_ROUND = {
  XSMALL: '4px', // --opds-sem-round-xsmall
  SMALL: '6px', // --opds-sem-round-small
  REGULAR: '8px', // --opds-sem-round-regular
  MEDIUM: '12px', // --opds-sem-round-medium
  LARGE: '20px', // --opds-sem-round-large
  FULL: '300px', // --opds-sem-round-full
} as const;

// === Semantic Dimension 토큰 ===
export const SEMANTIC_DIMENSION = {
  XXXSMALL: '14px', // --opds-sem-dimension-xxxsmall
  XXSMALL: '16px', // --opds-sem-dimension-xxsmall
  XSMALL: '20px', // --opds-sem-dimension-xsmall
  SMALL: '24px', // --opds-sem-dimension-small
  REGULAR: '28px', // --opds-sem-dimension-regular
  MEDIUM: '32px', // --opds-sem-dimension-medium
  LARGE: '36px', // --opds-sem-dimension-large
  XLARGE: '40px', // --opds-sem-dimension-xlarge
  XXLARGE: '48px', // --opds-sem-dimension-xxlarge
  XXXLARGE: '56px', // --opds-sem-dimension-xxxlarge
  XXXXLARGE: '60px', // --opds-sem-dimension-xxxxlarge
  XXXXXLARGE: '64px', // --opds-sem-dimension-xxxxxlarge
} as const;

// === Semantic Opacity 토큰 ===
export const SEMANTIC_OPACITY = {
  SMALL: 0.2, // --opds-sem-opacity-small
  REGULAR: 0.4, // --opds-sem-opacity-regular
  MEDIUM: 0.6, // --opds-sem-opacity-medium
} as const;

// === Semantic Color 토큰 ===
export const SEMANTIC_COLOR = {
  // Container
  CONTAINER: {
    NONE: {
      EMPTY: '#ffffff00', // --opds-sem-color-container-none-empty
      CRITICAL_LEVEL1: '#f05666', // --opds-sem-color-container-none-critical-level1
      CRITICAL_LEVEL2: '#ed3143', // --opds-sem-color-container-none-critical-level2
      CRITICAL_LEVEL3: '#e11428', // --opds-sem-color-container-none-critical-level3
      CRITICAL_LEVEL4: '#bc1021', // --opds-sem-color-container-none-critical-level4
    },
    STANDARD: {
      ALT_LEVEL1: '#ffffff', // --opds-sem-color-container-standard-alt-level1
      ALT_LEVEL2: '#f8f8f8', // --opds-sem-color-container-standard-alt-level2
      ALT_LEVEL3: '#f0f0f0', // --opds-sem-color-container-standard-alt-level3
      ALT_LEVEL4: '#e6e6e6', // --opds-sem-color-container-standard-alt-level4
      ALT_LEVEL5: '#cccccc', // --opds-sem-color-container-standard-alt-level5
      LEVEL1: '#101010', // --opds-sem-color-container-standard-level1
      LEVEL2: '#292929', // --opds-sem-color-container-standard-level2
      LEVEL3: '#424242', // --opds-sem-color-container-standard-level3
      LEVEL4: '#606060', // --opds-sem-color-container-standard-level4
      LEVEL5: '#757575', // --opds-sem-color-container-standard-level5
      LEVEL6: '#959595', // --opds-sem-color-container-standard-level6
      LEVEL7: '#b2b2b2', // --opds-sem-color-container-standard-level7
      OPACITY_LEVEL1: '#0000000a', // --opds-sem-color-container-standard-opacity-level1
      OPACITY_LEVEL2: '#00000014', // --opds-sem-color-container-standard-opacity-level2
      OPACITY_LEVEL3: '#0000001f', // --opds-sem-color-container-standard-opacity-level3
      OPACITY_LEVEL4: '#00000033', // --opds-sem-color-container-standard-opacity-level4
    },
    PRIMARY: {
      ALT_LEVEL1: '#f2edfd', // --opds-sem-color-container-primary-alt-level1
      ALT_LEVEL2: '#e4dafb', // --opds-sem-color-container-primary-alt-level2
      ALT_LEVEL3: '#d7c8f9', // --opds-sem-color-container-primary-alt-level3
      ALT_LEVEL4: '#c9b6f7', // --opds-sem-color-container-primary-alt-level4
      ALT_LEVEL5: '#b59af4', // --opds-sem-color-container-primary-alt-level5
      LEVEL1: '#3b119c', // --opds-sem-color-container-primary-level1
      LEVEL2: '#4915c1', // --opds-sem-color-container-primary-level2
      LEVEL3: '#5318dc', // --opds-sem-color-container-primary-level3
      LEVEL4: '#642ce8', // --opds-sem-color-container-primary-level4
      LEVEL5: '#7847eb', // --opds-sem-color-container-primary-level5
      LEVEL6: '#8d63ee', // --opds-sem-color-container-primary-level6
      OPACITY_LEVEL1: '#642ce80a', // --opds-sem-color-container-primary-opacity-level1
      OPACITY_LEVEL2: '#642ce814', // --opds-sem-color-container-primary-opacity-level2
      OPACITY_LEVEL3: '#642ce81f', // --opds-sem-color-container-primary-opacity-level3
      OPACITY_LEVEL4: '#642ce833', // --opds-sem-color-container-primary-opacity-level4
      OPACITY_LEVEL5: '#642ce866', // --opds-sem-color-container-primary-opacity-level5
    },
    COLORFUL: {
      RED: {
        LEVEL1: '#fdecee', // --opds-sem-color-container-colorful-red-level1
        LEVEL2: '#fcd9dd', // --opds-sem-color-container-colorful-red-level2
        LEVEL3: '#f9bdc3', // --opds-sem-color-container-colorful-red-level3
        LEVEL4: '#ed3143', // --opds-sem-color-container-colorful-red-level4
      },
      MAGENTA: {
        LEVEL1: '#fdecf5', // --opds-sem-color-container-colorful-magenta-level1
        LEVEL2: '#fcd9eb', // --opds-sem-color-container-colorful-magenta-level2
        LEVEL3: '#f7a1cc', // --opds-sem-color-container-colorful-magenta-level3
        LEVEL4: '#ed318f', // --opds-sem-color-container-colorful-magenta-level4
      },
      FUCHSIA: {
        LEVEL1: '#fcecfd', // --opds-sem-color-container-colorful-fuchsia-level1
        LEVEL2: '#f8d9fc', // --opds-sem-color-container-colorful-fuchsia-level2
        LEVEL3: '#f3bdf9', // --opds-sem-color-container-colorful-fuchsia-level3
        LEVEL4: '#e156f0', // --opds-sem-color-container-colorful-fuchsia-level4
      },
      PURPLE: {
        LEVEL1: '#f2edfd', // --opds-sem-color-container-colorful-purple-level1
        LEVEL2: '#e4dafb', // --opds-sem-color-container-colorful-purple-level2
        LEVEL3: '#d7c8f9', // --opds-sem-color-container-colorful-purple-level3
        LEVEL4: '#7847eb', // --opds-sem-color-container-colorful-purple-level4
      },
      INDIGO: {
        LEVEL1: '#edeefd', // --opds-sem-color-container-colorful-indigo-level1
        LEVEL2: '#dadefb', // --opds-sem-color-container-colorful-indigo-level2
        LEVEL3: '#b6bcf7', // --opds-sem-color-container-colorful-indigo-level3
        LEVEL4: '#6371ee', // --opds-sem-color-container-colorful-indigo-level4
      },
      BLUE: {
        LEVEL1: '#e3f0fd', // --opds-sem-color-container-colorful-blue-level1
        LEVEL2: '#bddbf9', // --opds-sem-color-container-colorful-blue-level2
        LEVEL3: '#98c7f6', // --opds-sem-color-container-colorful-blue-level3
        LEVEL4: '#318fed', // --opds-sem-color-container-colorful-blue-level4
      },
      TURQUOISE: {
        LEVEL1: '#d6f2f5', // --opds-sem-color-container-colorful-turquoise-level1
        LEVEL2: '#a5e2e9', // --opds-sem-color-container-colorful-turquoise-level2
        LEVEL3: '#74d2dc', // --opds-sem-color-container-colorful-turquoise-level3
        LEVEL4: '#2faebc', // --opds-sem-color-container-colorful-turquoise-level4
      },
      OLIVE: {
        LEVEL1: '#e5f2d9', // --opds-sem-color-container-colorful-olive-level1
        LEVEL2: '#c7e2ac', // --opds-sem-color-container-colorful-olive-level2
        LEVEL3: '#a8d27f', // --opds-sem-color-container-colorful-olive-level3
        LEVEL4: '#619b27', // --opds-sem-color-container-colorful-olive-level4
      },
      CHARTREUSE: {
        LEVEL1: '#eff2d9', // --opds-sem-color-container-colorful-chartreuse-level1
        LEVEL2: '#dce2ac', // --opds-sem-color-container-colorful-chartreuse-level2
        LEVEL3: '#cad27f', // --opds-sem-color-container-colorful-chartreuse-level3
        LEVEL4: '#808b23', // --opds-sem-color-container-colorful-chartreuse-level4
      },
      YELLOW: {
        LEVEL1: '#fef6e1', // --opds-sem-color-container-colorful-yellow-level1
        LEVEL2: '#fee9b9', // --opds-sem-color-container-colorful-yellow-level2
        LEVEL3: '#fddc91', // --opds-sem-color-container-colorful-yellow-level3
        LEVEL4: '#fab719', // --opds-sem-color-container-colorful-yellow-level4
      },
      ORANGE: {
        LEVEL1: '#feeae1', // --opds-sem-color-container-colorful-orange-level1
        LEVEL2: '#feceb9', // --opds-sem-color-container-colorful-orange-level2
        LEVEL3: '#fdb191', // --opds-sem-color-container-colorful-orange-level3
        LEVEL4: '#fb6423', // --opds-sem-color-container-colorful-orange-level4
      },
      GREEN: {
        LEVEL1: '#d3f8de', // --opds-sem-color-container-colorful-green-level1
        LEVEL2: '#a5e9d4', // --opds-sem-color-container-colorful-green-level2
        LEVEL3: '#74dcbd', // --opds-sem-color-container-colorful-green-level3
        LEVEL4: '#2fbc91', // --opds-sem-color-container-colorful-green-level4
      },
      EMERALD: {
        LEVEL1: '#d6f5ec', // --opds-sem-color-container-colorful-emerald-level1
        LEVEL2: '#a5e9d4', // --opds-sem-color-container-colorful-emerald-level2
        LEVEL3: '#74dcbd', // --opds-sem-color-container-colorful-emerald-level3
        LEVEL4: '#2fbc91', // --opds-sem-color-container-colorful-emerald-level4
      },
      GRAY: {
        LEVEL1: '#f0f0f0', // --opds-sem-color-container-colorful-gray-level1
        LEVEL2: '#e6e6e6', // --opds-sem-color-container-colorful-gray-level2
        LEVEL3: '#cccccc', // --opds-sem-color-container-colorful-gray-level3
        LEVEL4: '#757575', // --opds-sem-color-container-colorful-gray-level4
      },
    },
  },
  // OnContainer
  ON_CONTAINER: {
    STANDARD: {
      LEVEL1: '#101010', // --opds-sem-color-onContainer-standard-level1
      LEVEL2: '#292929', // --opds-sem-color-onContainer-standard-level2
      LEVEL3: '#424242', // --opds-sem-color-onContainer-standard-level3
      LEVEL4: '#606060', // --opds-sem-color-onContainer-standard-level4
      LEVEL5: '#757575', // --opds-sem-color-onContainer-standard-level5
      LEVEL6: '#959595', // --opds-sem-color-onContainer-standard-level6
      LEVEL7: '#b2b2b2', // --opds-sem-color-onContainer-standard-level7
    },
    PRIMARY: {
      LEVEL1: '#3b119c', // --opds-sem-color-onContainer-primary-level1
      LEVEL2: '#4915c1', // --opds-sem-color-onContainer-primary-level2
      LEVEL3: '#5318dc', // --opds-sem-color-onContainer-primary-level3
      LEVEL4: '#642ce8', // --opds-sem-color-onContainer-primary-level4
      LEVEL5: '#7847eb', // --opds-sem-color-onContainer-primary-level5
      LEVEL6: '#8d63ee', // --opds-sem-color-onContainer-primary-level6
    },
    COLORFUL: {
      RED: '#e11428', // --opds-sem-color-onContainer-colorful-red
      MAGENTA: '#ed318f', // --opds-sem-color-onContainer-colorful-magenta
      FUCHSIA: '#da31ed', // --opds-sem-color-onContainer-colorful-fuchsia
      PURPLE: '#7847eb', // --opds-sem-color-onContainer-colorful-purple
      INDIGO: '#4758eb', // --opds-sem-color-onContainer-colorful-indigo
      BLUE: '#116bc5', // --opds-sem-color-onContainer-colorful-blue
      TURQUOISE: '#157984', // --opds-sem-color-onContainer-colorful-turquoise
      EMERALD: '#137255', // --opds-sem-color-onContainer-colorful-emerald
      GREEN: '#18953e', // --opds-sem-color-onContainer-colorful-green
      OLIVE: '#578b23', // --opds-sem-color-onContainer-colorful-olive
      CHARTREUSE: '#808b23', // --opds-sem-color-onContainer-colorful-chartreuse
      YELLOW: '#be8604', // --opds-sem-color-onContainer-colorful-yellow
      ORANGE: '#f04b05', // --opds-sem-color-onContainer-colorful-orange
      GRAY: '#101010', // --opds-sem-color-onContainer-colorful-gray
      WHITE: '#ffffff', // --opds-sem-color-onContainer-colorful-white
    },
    INVERSE: {
      LEVEL1: '#ffffff', // --opds-sem-color-onContainer-inverse-level1
      LEVEL2: '#ffffff99', // --opds-sem-color-onContainer-inverse-level2
      LEVEL3: '#ffffff66', // --opds-sem-color-onContainer-inverse-level3
      LEVEL4: '#ffffff33', // --opds-sem-color-onContainer-inverse-level4
    },
    NONE: {
      CRITICAL: '#ed3143', // --opds-sem-color-onContainer-none-critical
    },
  },
  // Surface
  SURFACE: {
    STANDARD: {
      LEVEL1: '#ffffff', // --opds-sem-color-surface-standard-level1
      LEVEL2: '#f8f8f8', // --opds-sem-color-surface-standard-level2
      LEVEL3: '#f0f0f0', // --opds-sem-color-surface-standard-level3
      LEVEL4: '#e6e6e6', // --opds-sem-color-surface-standard-level4
      OPACITY_LEVEL1: '#ffffffcc', // --opds-sem-color-surface-standard-opacity-level1
    },
    INVERSE: {
      LEVEL1: '#000000', // --opds-sem-color-surface-inverse-level1
      LEVEL2: '#101010', // --opds-sem-color-surface-inverse-level2
      LEVEL3: '#292929', // --opds-sem-color-surface-inverse-level3
      LEVEL4: '#424242', // --opds-sem-color-surface-inverse-level4
    },
  },
  // OnSurface
  ON_SURFACE: {
    STANDARD: {
      LEVEL1: '#101010', // --opds-sem-color-onSurface-standard-level1
      LEVEL2: '#292929', // --opds-sem-color-onSurface-standard-level2
      LEVEL3: '#424242', // --opds-sem-color-onSurface-standard-level3
      LEVEL4: '#606060', // --opds-sem-color-onSurface-standard-level4
      LEVEL5: '#757575', // --opds-sem-color-onSurface-standard-level5
      LEVEL6: '#959595', // --opds-sem-color-onSurface-standard-level6
      LEVEL7: '#b2b2b2', // --opds-sem-color-onSurface-standard-level7
    },
    PRIMARY: {
      LEVEL1: '#3b119c', // --opds-sem-color-onSurface-primary-level1
      LEVEL2: '#4915c1', // --opds-sem-color-onSurface-primary-level2
      LEVEL3: '#642ce8', // --opds-sem-color-onSurface-primary-level3
    },
    INVERSE: {
      LEVEL1: '#ffffff', // --opds-sem-color-onSurface-inverse-level1
      LEVEL2: '#ffffff99', // --opds-sem-color-onSurface-inverse-level2
      LEVEL3: '#ffffff66', // --opds-sem-color-onSurface-inverse-level3
    },
  },
} as const;

export const cssVar = {
  fontFamily: (name: keyof typeof FONT.FAMILY) => `var(--opds-glo-font-family-${name.toLowerCase()})`,
  fontSize: (size: keyof typeof FONT.SIZE) => {
    const sizeMap: Record<keyof typeof FONT.SIZE, string> = {
      XS: '11',
      SM: '12',
      BASE: '14',
      LG: '16',
      XL: '20',
      '2XL': '24',
      '3XL': '28',
      '4XL': '32',
      '5XL': '36',
      '6XL': '48',
      '7XL': '56',
    };
    return `var(--opds-glo-font-size-${sizeMap[size]})`;
  },
  fontWeight: (weight: keyof typeof FONT.WEIGHT) => {
    const weightMap: Record<keyof typeof FONT.WEIGHT, string> = {
      REGULAR: 'regular',
      BOLD: 'bold',
      EXTRA_BOLD: 'extraBold',
    };
    return `var(--opds-glo-font-weight-${weightMap[weight]})`;
  },
  lineHeight: (height: keyof typeof FONT.LINE_HEIGHT) => `var(--opds-glo-font-height-${height})`,

  space: (size: keyof typeof SPACE) => `var(--opds-glo-space-${size})`,

  guideBlank: () => `var(--opds-glo-palette-guide-blank)`,
  brandBlue: () => `var(--opds-glo-palette-brand-blue)`,
  brandOrange: () => `var(--opds-glo-palette-brand-orange)`,
  gray: (shade: keyof typeof COLOR.GRAY) => `var(--opds-glo-palette-gray-${shade})`,
  red: (shade: keyof typeof COLOR.RED) => `var(--opds-glo-palette-red-${shade})`,
  magenta: (shade: keyof typeof COLOR.MAGENTA) => `var(--opds-glo-palette-magenta-${shade})`,
  fuchsia: (shade: keyof typeof COLOR.FUCHSIA) => `var(--opds-glo-palette-fuchsia-${shade})`,
  purple: (shade: keyof typeof COLOR.PURPLE) => `var(--opds-glo-palette-purple-${shade})`,
  indigo: (shade: keyof typeof COLOR.INDIGO) => `var(--opds-glo-palette-indigo-${shade})`,
  blue: (shade: keyof typeof COLOR.BLUE) => `var(--opds-glo-palette-blue-${shade})`,
  turquoise: (shade: keyof typeof COLOR.TURQUOISE) => `var(--opds-glo-palette-turquoise-${shade})`,
  emerald: (shade: keyof typeof COLOR.EMERALD) => `var(--opds-glo-palette-emerald-${shade})`,
  green: (shade: keyof typeof COLOR.GREEN) => `var(--opds-glo-palette-green-${shade})`,
  olive: (shade: keyof typeof COLOR.OLIVE) => `var(--opds-glo-palette-olive-${shade})`,
  chartreuse: (shade: keyof typeof COLOR.CHARTREUSE) => `var(--opds-glo-palette-chartreuse-${shade})`,
  yellow: (shade: keyof typeof COLOR.YELLOW) => `var(--opds-glo-palette-yellow-${shade})`,
  orange: (shade: keyof typeof COLOR.ORANGE) => `var(--opds-glo-palette-orange-${shade})`,

  radius: (size: keyof typeof RADIUS) =>
    size === 'FULL' ? `var(--opds-glo-radius-300)` : `var(--opds-glo-radius-${size})`,

  alpha: (level: keyof typeof ALPHA) => `var(--opds-glo-alpha-${level})`,

  borderWidth: (width: keyof typeof BORDER_WIDTH) => `var(--opds-glo-border-width-${width})`,

  semGap: (size: keyof typeof SEMANTIC_GAP) => {
    const gapMap: Record<keyof typeof SEMANTIC_GAP, string> = {
      XXSMALL: 'xxsmall',
      XSMALL: 'xsmall',
      SMALL: 'small',
      REGULAR: 'regular',
      MEDIUM: 'medium',
      XLARGE: 'xlarge',
    };
    return `var(--opds-sem-gap-${gapMap[size]})`;
  },

  semRound: (size: keyof typeof SEMANTIC_ROUND) => {
    const roundMap: Record<keyof typeof SEMANTIC_ROUND, string> = {
      XSMALL: 'xsmall',
      SMALL: 'small',
      REGULAR: 'regular',
      MEDIUM: 'medium',
      LARGE: 'large',
      FULL: 'full',
    };
    return `var(--opds-sem-round-${roundMap[size]})`;
  },

  semDimension: (size: keyof typeof SEMANTIC_DIMENSION) => {
    const dimensionMap: Record<keyof typeof SEMANTIC_DIMENSION, string> = {
      XXXSMALL: 'xxxsmall',
      XXSMALL: 'xxsmall',
      XSMALL: 'xsmall',
      SMALL: 'small',
      REGULAR: 'regular',
      MEDIUM: 'medium',
      LARGE: 'large',
      XLARGE: 'xlarge',
      XXLARGE: 'xxlarge',
      XXXLARGE: 'xxxlarge',
      XXXXLARGE: 'xxxxlarge',
      XXXXXLARGE: 'xxxxxlarge',
    };
    return `var(--opds-sem-dimension-${dimensionMap[size]})`;
  },

  // Semantic Opacity
  semOpacity: (level: keyof typeof SEMANTIC_OPACITY) => {
    const opacityMap: Record<keyof typeof SEMANTIC_OPACITY, string> = {
      SMALL: 'small',
      REGULAR: 'regular',
      MEDIUM: 'medium',
    };
    return `var(--opds-sem-opacity-${opacityMap[level]})`;
  },

  // Semantic Color - Container
  semColorContainerNoneEmpty: () => `var(--opds-sem-color-container-none-empty)`,
  semColorContainerStandardOpacityLevel1: () => `var(--opds-sem-color-container-standard-opacity-level1)`,
  semColorContainerStandardAltLevel1: () => `var(--opds-sem-color-container-standard-alt-level1)`,
  semColorContainerStandardAltLevel2: () => `var(--opds-sem-color-container-standard-alt-level2)`,
  semColorContainerPrimaryLevel4: () => `var(--opds-sem-color-container-primary-level4)`,

  semColorOnContainerStandardLevel1: () => `var(--opds-sem-color-onContainer-standard-level1)`,
  semColorOnContainerStandardLevel4: () => `var(--opds-sem-color-onContainer-standard-level4)`,
  semColorOnContainerPrimaryLevel4: () => `var(--opds-sem-color-onContainer-primary-level4)`,
} as const;

export const commonStyles = {
  bodyText: {
    fontFamily: FONT.FAMILY.NANUMSQUARE,
    fontSize: `${FONT.SIZE.BASE}px`,
    fontWeight: FONT.WEIGHT.REGULAR,
    lineHeight: `${FONT.LINE_HEIGHT[20]}px`,
    color: COLOR.GRAY[10],
  },

  headingText: {
    fontFamily: FONT.FAMILY.NANUMSQUARE,
    fontSize: `${FONT.SIZE['3XL']}px`,
    fontWeight: FONT.WEIGHT.BOLD,
    lineHeight: `${FONT.LINE_HEIGHT[36]}px`,
    color: COLOR.GRAY[10],
  },

  card: {
    backgroundColor: COLOR.GRAY[100],
    borderRadius: `${RADIUS[8]}px`,
    padding: `${SPACE[16]}px`,
    boxShadow: `0 1px 3px rgba(0, 0, 0, ${ALPHA[20]})`,
  },

  primaryButton: {
    backgroundColor: COLOR.PURPLE[30],
    color: COLOR.GRAY[100],
    fontFamily: FONT.FAMILY.NANUMSQUARE,
    fontSize: `${FONT.SIZE.BASE}px`,
    fontWeight: FONT.WEIGHT.BOLD,
    padding: `${SPACE[12]}px ${SPACE[24]}px`,
    borderRadius: `${RADIUS[8]}px`,
    border: 'none',
    cursor: 'pointer',
  },
} as const;

export const cssVarStyles = {
  bodyText: {
    fontFamily: cssVar.fontFamily('NANUMSQUARE'),
    fontSize: cssVar.fontSize('BASE'),
    fontWeight: cssVar.fontWeight('REGULAR'),
    lineHeight: cssVar.lineHeight(20),
    color: cssVar.gray(10),
  },

  headingText: {
    fontFamily: cssVar.fontFamily('NANUMSQUARE'),
    fontSize: cssVar.fontSize('3XL'),
    fontWeight: cssVar.fontWeight('BOLD'),
    lineHeight: cssVar.lineHeight(36),
    color: cssVar.gray(10),
  },

  card: {
    backgroundColor: cssVar.gray(100),
    borderRadius: cssVar.radius(8),
    padding: cssVar.space(16),
  },

  primaryButton: {
    backgroundColor: cssVar.purple(30),
    color: cssVar.gray(100),
    fontFamily: cssVar.fontFamily('NANUMSQUARE'),
    fontSize: cssVar.fontSize('BASE'),
    fontWeight: cssVar.fontWeight('BOLD'),
    padding: `${cssVar.space(12)} ${cssVar.space(24)}`,
    borderRadius: cssVar.radius(8),
    border: 'none',
    cursor: 'pointer',
  },

  transparentContainer: {
    backgroundColor: cssVar.semColorContainerNoneEmpty(),
  },

  standardContainerOpacity: {
    backgroundColor: cssVar.semColorContainerStandardOpacityLevel1(),
  },

  gapRegular: {
    gap: cssVar.semGap('REGULAR'),
  },

  gapMedium: {
    gap: cssVar.semGap('MEDIUM'),
  },

  gapXlarge: {
    gap: cssVar.semGap('XLARGE'),
  },

  roundSmall: {
    borderRadius: cssVar.semRound('SMALL'),
  },

  roundRegular: {
    borderRadius: cssVar.semRound('REGULAR'), // 8px
  },
} as const;

// === 타입 정의 ===
export type FontSize = keyof typeof FONT.SIZE;
export type FontWeight = keyof typeof FONT.WEIGHT;
export type SpaceSize = keyof typeof SPACE;
export type GrayShade = keyof typeof COLOR.GRAY;
export type RedShade = keyof typeof COLOR.RED;
export type MagentaShade = keyof typeof COLOR.MAGENTA;
export type FuchsiaShade = keyof typeof COLOR.FUCHSIA;
export type PurpleShade = keyof typeof COLOR.PURPLE;
export type IndigoShade = keyof typeof COLOR.INDIGO;
export type BlueShade = keyof typeof COLOR.BLUE;
export type TurquoiseShade = keyof typeof COLOR.TURQUOISE;
export type EmeraldShade = keyof typeof COLOR.EMERALD;
export type GreenShade = keyof typeof COLOR.GREEN;
export type OliveShade = keyof typeof COLOR.OLIVE;
export type ChartreuseShade = keyof typeof COLOR.CHARTREUSE;
export type YellowShade = keyof typeof COLOR.YELLOW;
export type OrangeShade = keyof typeof COLOR.ORANGE;
export type RadiusSize = keyof typeof RADIUS;
export type AlphaLevel = keyof typeof ALPHA;
export type BorderWidthSize = keyof typeof BORDER_WIDTH;

export type SemanticGapSize = keyof typeof SEMANTIC_GAP;
export type SemanticRoundSize = keyof typeof SEMANTIC_ROUND;
export type SemanticDimensionSize = keyof typeof SEMANTIC_DIMENSION;
export type SemanticOpacityLevel = keyof typeof SEMANTIC_OPACITY;
